export const fonts = {
  anton: "'Anton', sans-serif",
  geist: "'Geist', sans-serif",
}